import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { Button } from '@blueprint/ui';
import styled from "styled-components";
import { NoRecordCard } from "../../../common/components";
import { Table } from "../../../common/components/core";
import { SuperAdminRole } from "../../../types/superadmin";
import { FormSubmissionHandler } from "../../../types/common";
import { UserProfileRelationship } from "../../../types/relationship";
import RelationshipForm, { RelationshipFormValues } from "./RelationshipForm"



type RelationshipListProps = {
    accountType: SuperAdminRole;
    relationships: UserProfileRelationship[];
    onSubmit: FormSubmissionHandler<RelationshipFormValues>;
    temp: UserProfileRelationship | null;
    setTemp: (relationship: UserProfileRelationship | null) => void;
};

const RelationshipList = ({
    accountType,
    relationships,
    onSubmit,
    temp,
    setTemp,
}: RelationshipListProps): JSX.Element => {

    useEffect(() => {

        const editMode = () => {
            if (!temp) {
                return;
            }
        }

        editMode();
        return () => {
        };
    }, [temp]);

    const edit = (relationship: UserProfileRelationship) => {
        setTemp(relationship);
    }
    const cancel = () => {
        setTemp(null);
    }

    return relationships.length === 0 ?
        <NoRecordCard /> :
            !!temp ?
                <RelationshipForm
                    relationship={temp}
                    onSubmit={onSubmit}
                    onCancel={cancel}
                /> :
                    (
                        <Card className="mt-4 border-0">
                            <Card.Body className="px-0 py-0">
                                <table className={'custom-table'}>
                                    <thead>
                                        <tr>
                                            <Table.HeaderCell width={100}>
                                                Relationship
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={200}>
                                                Service Provider
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={200}>
                                                Approver
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={50}>
                                                Action
                                            </Table.HeaderCell>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {relationships.map((relationship, index) => (
                                            <Table.BodyRow
                                                key={index}
                                            >
                                                <StyledTd>{relationship.developerUserProfile?.name}</StyledTd>
                                                <StyledTd>{relationship.contractorAccountNameList && relationship.contractorAccountNameList.map((value, cIndex) => {
                                                    return <div key={cIndex}>{value.name}</div>
                                                })}
                                                </StyledTd>
                                                <StyledTd>{relationship.approverUserProfileList && relationship.approverUserProfileList.map((value, aIndex) => {
                                                    return <div key={aIndex}>{value.name}</div>
                                                })}
                                                </StyledTd>
                                                <StyledTd>
                                                    <Button variant="light.primary" onClick={() => edit(relationship)}>
                                                        Edit
                                                    </Button>
                                                </StyledTd>
                                            </Table.BodyRow>
                                        ))}
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    );
};

const StyledTd = styled.td`
    vertical-align: top;
`;

export default RelationshipList;
